// THE-300/301: demographic values never reach Sentry or the console. Mirror
// of the backend scrubber in backend/core/sentry.py: an exact key match, also
// for a dotted tag suffix such as `api.gender`. The Sentry hooks and the
// error parser read this one list, thus a new key goes into both.
const DEMOGRAPHIC_KEYS: ReadonlySet<string> = new Set([
  'age',
  'age_group',
  'age_group_list',
  'demographics',
  'detected_age',
  'detected_gender',
  'detected_race',
  'gender',
  'gender_list',
  'race',
  'race_list',
]);

export function isDemographicKey(key: string): boolean {
  const leaf = key.slice(key.lastIndexOf('.') + 1).toLowerCase();
  return DEMOGRAPHIC_KEYS.has(leaf);
}
